import React from "react"
import type { PreviewBlock } from "@/lib/types"

const bar = "h-3 rounded bg-muted"

function Block({ block }: { block: PreviewBlock }) {
  switch (block.type) {
    case "text":
      return (
        <div className="space-y-2.5">
          {Array.from({ length: block.lines }, (_, i) => (
            <div key={i} className={`${bar} ${i === block.lines - 1 ? "w-2/3" : "w-full"}`} />
          ))}
        </div>
      )
    case "list":
      return (
        <div className="space-y-2.5 pl-2">
          {Array.from({ length: block.items }, (_, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="h-1.5 w-1.5 shrink-0 rounded-full bg-muted" />
              <div className={`${bar} w-1/2`} />
            </div>
          ))}
        </div>
      )
    case "table":
      return (
        <div className="space-y-2">
          {Array.from({ length: block.rows }, (_, r) => (
            <div key={r} className="grid grid-cols-3 gap-2">
              {[0, 1, 2].map((c) => (
                <div key={c} className="h-8 rounded bg-muted" />
              ))}
            </div>
          ))}
        </div>
      )
  }
}

export function PreviewPlaceholder({ blocks }: { blocks: PreviewBlock[] }) {
  return (
    <div aria-hidden="true" className="select-none space-y-5 py-3">
      {blocks.map((block, i) => (
        <Block key={i} block={block} />
      ))}
    </div>
  )
}
